import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import logo from '../../img/LogoMakr-2dsx6X.png'
import './navbar.scss'
import resume from '../../resume/my_resume.pdf'
const Navbar = () => {
  const location = useLocation()
  const classNames = require('classnames');

  window.addEventListener('scroll', function () {
    let head = document.querySelector('.navbar')
    head.classList.toggle('sticky', window.scrollY > 0)
  })

  const navActive = () => {
    if (window.innerWidth < 990) {
      const hamburger = document.querySelector(".hamburger");
      const navMenu = document.querySelector(".navbar-menu-group");
      const blurback = document.querySelector('.blur-background')

      blurback.classList.toggle("blur-back-show")
      hamburger.classList.toggle("active");
      navMenu.classList.toggle("nav-active");
    }
  }

  const menu = [{
    id: 1,
    pathname: '/',
    menuName: 'Главный',
  },
  {
    id: 2,
    pathname: '/about',
    menuName: 'Про меня',
  },
  {
    id: 3,
    pathname: '/portfolio',
    menuName: 'Портфолио',
  },
  {
    id: 4,
    pathname: '/faqs',
    menuName: 'Вопросы',
  }]

  return (
    <>
      <div className='blur-background'></div>
      <header>
        <div className='navbar'>
          <div className='navbar-logo-brand'>
            <Link to='/'>
              <img alt='' src={logo} />
            </Link>
          </div>
          <div className='navbar-menu-group'>
            <div className='navbar-menu-item'>
              {
                menu.map(item => {
                  let activeClass = classNames({
                    hoverLink: true,
                    active: location.pathname === item.pathname
                  });
                  return (
                    <div key={item.id}>
                      <h4 className={activeClass}>
                        <Link to={item.pathname} onClick={navActive}><span>0{item.id}.</span>{item.menuName}</Link>
                      </h4>
                    </div>
                  )
                })
              }

            </div>
            <a href={resume} download={'my_resume.pdf'} className='btn-link'>Резюме</a>
          </div>
          <div className="hamburger" onClick={navActive}>
            <span className="bar" />
            <span className="bar" />
            <span className="bar" />
          </div>
        </div>
      </header >
    </>
  )
}
export default Navbar